import { combineReducers, combineSlices } from "@reduxjs/toolkit";

import emailServerReducer from "../emailServer/emailServerSlice";
import { integrationsSlice } from "../integrations/integrationsSlice";

const cloudReducer = combineReducers({
  emailserver: emailServerReducer,
});

export const adminReducer = combineSlices(integrationsSlice, { cloud: cloudReducer });
